<template>
    <div class="table-responsive col-lg-12">
      <aDataTable :data="orders">
        <template #columns>
          <tr>
            <th>Name</th>
            <th>Client</th>
            <th>Group</th>
            <th>Supplier</th>
            <th>Type</th>
            <th>Added</th>
            <th>Topic</th>
            <th>Language</th>
            <th>Country</th>
            <th>Waiting</th>
            <th>Building</th>
            <th>Completed</th>
            <th>Live</th>
            <th>Status</th>
          </tr>
        </template>
        <template #rows>
          <tr v-for="order in orders" :key="order.id">
            <td>
              <i class="fas fa-user" title="Domains supplied by the client" v-if="order.domainSupplier === 'client'"></i>
              <i class="fas fa-house-user" title="Domains supplied in-house" v-else-if="order.domainSupplier === 'in-house'"></i>
              <i class="fas fa-question" title="Domains supplied in-house" v-else></i>
              <router-link :to="'/pbn/order/' + order.id">{{ order.name || '/' }}</router-link>
            </td>
            <td>{{ order.client ? order.client.name : '/'}}</td>
            <td>{{ order.group ? order.group.name : '/'}}</td>
            <td>{{ order.domainSupplier }}</td>
            <td>{{ order.type || 'pbn' }}</td>
            <td>{{ order.added | aTime('DD.MM.YYYY') }}</td>
            <td>{{ order.targetTopic || '/' }}</td>
            <td>{{ order.targetLanguage || '/' }}</td>
            <td>{{ order.targetCountry || '/' }}</td>
            <td class="center">
              {{ order | waiting }}
            </td>
            <td class="center">{{ order | building }}</td>
            <td class="center">{{ order | completed }}</td>
            <td class="center">{{ order | live }}</td>
            <td>
              {{ order.status }}
            </td>
          </tr>
        </template>
      </aDataTable>
    </div>
</template>
<script>
import BuildsBreakdown from './BuildsBreakdown'

export default {
  props: ['orders'],
  components: {
    breakdown: BuildsBreakdown
  },
  filters: {
    completed (order) {
      if (!order.completion || !order.completion.built) return 0
      return order.completion.built.completed
    },
    waiting (order) {
      if (!order.completion || !order.completion.added) return 0
      return order.completion.added.waiting
    },
    building (order) {
      if (!order.completion || !order.completion.built) return '0'
      return order.completion.built.assigned
    },
    live (order) {
      if (!order.completion || !order.completion['site-moved']) return 0
      return order.completion['site-moved'].completed
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Orders/BuildsList.vue